import React from "react";
import { Label } from "@components/typography/Label";
import locale from "@bonliva-crm/locale";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    textAlign: "center",
    padding: theme.spacing(),
    borderRadius: theme.radius,
    color: theme.palette.info.text,
    backgroundColor: theme.palette.info.background
  }
}));

type Props = {
  children?: React.ReactNode;
};

export function EmptyList({ children }: Props) {
  const classes = useStyles({});
  return (
    <div className={classes.root}>
      <Label>{children || locale.NoSearchResults}</Label>
    </div>
  );
}
